<template>
  <l-dialog
    :auto-close="false"
    :disable-confirm="currentId === selectId"
    @cancel="cancel"
    @confirm="confirm"
    title="切换单位"
    v-model="show"
    width="350px"
  >
    <slot name="activator" slot="activator"></slot>
    <v-layout align-center class="pb-5 pt-2" justify-center v-if="getLoading">
      <v-progress-circular color="primary" indeterminate size="50" width="2"></v-progress-circular>
    </v-layout>
    <v-list v-else>
      <v-divider></v-divider>
      <template v-for="org in orgItems">
        <v-list-tile :key="org.id" @click="select = org" ripple>
          <v-list-tile-avatar>
            <v-icon :color="selectId === org.id ? 'primary':''" small>$vuetify.icons.group</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content :class="selectId === org.id ? 'primary--text':''">{{org.name}}</v-list-tile-content>
          <v-list-tile-action v-if="selectId === org.id">
            <v-icon color="primary">mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider :key="org.id + 'd'"></v-divider>
      </template>
    </v-list>
    <v-alert :value="true" type="warning" v-if="select && currentId !== selectId">
      切换单位将清除所有未保存的操作！
    </v-alert>
  </l-dialog>
</template>

<script>
export default {
  name: 'orgDialog',
  data: () => ({
    show: false,
    select: null,
    getLoading: false,
    submitLoading: false,
    orgItems: []
  }),
  computed: {
    current () {
      return this.$store.getters['login/getCurrentOrg']
    },
    currentId () {
      return this.current && this.current.id
    },
    selectId () {
      return this.select && this.select.id
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.select = this.current
        console.log('set sekect', this.select, this.current)
        this.getOrgs()
      }
    }
  },
  methods: {
    async confirm () {
      console.log('confirm', this.select)
      try {
        this.submitLoading = true
        await this.$store.dispatch('login/switchCurrentOrg', this.select)
        this.changeSystemOption()
        this.show = false
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    cancel () {
      console.log('cancel')
      this.show = false
    },
    changeSystemOption () {
      console.log('system org switch to', this.select)
      this.$store.commit('login/setCurrentOrg', this.select)
      this.$L.cfg.appName.subTitle = this.current.name
    },
    async getOrgs () {
      try {
        this.getLoading = true
        this.orgItems = await this.$store.dispatch('login/getAvailableOrg')
        console.log('get org', this.orgItems)
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.getLoading = false
      }
    }
  },
}
</script>

<style scoped>

</style>
